import { useMemo } from 'react';
import { isListAsset, isMarketingEmailAsset, isFormAsset, isWorkflowAsset } from '../types';
export function useAllowedAssets(assets) {
  return useMemo(() => {
    const allowedAssets = [];
    const disallowedAssets = [];
    assets.forEach(asset => {
      if (isMarketingEmailAsset(asset)) {
        if (asset.metadata['marketing-email'].emailType === 'AUTOMATED_EMAIL') {
          allowedAssets.push(asset);
          return;
        } else {
          disallowedAssets.push(Object.assign({}, asset, {
            skipReason: 'NOT_AUTOMATED_EMAIL'
          }));
          return;
        }
      }
      if (isListAsset(asset)) {
        allowedAssets.push(asset);
        return;
      }
      if (isFormAsset(asset)) {
        allowedAssets.push(asset);
        return;
      }
      if (isWorkflowAsset(asset)) {
        if (asset.metadata.workflows.portableKey) {
          allowedAssets.push(asset);
          return;
        } else {
          disallowedAssets.push(Object.assign({}, asset, {
            skipReason: 'NO_PORTABLE_KEY'
          }));
          return;
        }
      }
      console.error('Asset type not supported');
    });
    return [allowedAssets, disallowedAssets];
  }, [assets]);
}